import React from "react";

export default () => (
  <section className="section has-text-centered">
    <h1 className="title"> Page Not Found"</h1>
  </section>
);



// WEBPACK FOOTER //
// ./src/pages/NotFound/index.js